import React from "react";
import { Dialog, DialogContent } from "@mui/material";

const LOCATIONS = ["Office", "Work From Home", "Client Office"];

const AttendanceDialog = ({
  open,
  mode = "IN",
  isLoading,
  dropdownValue,
  comments,
  onClose,
  onLocationChange,
  onCommentsChange,
  onSubmit,
}) => {
  const signingOut = mode === "OUT";
  const label = signingOut ? "Sign Out" : "Sign In";
  const disabled = dropdownValue === "" || dropdownValue === "Select";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { borderRadius: 16 } }}
    >
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
        <h2 className="text-lg font-bold tracking-tight text-gray-800">
          {label} Details
        </h2>
        <button
          type="button"
          className="text-2xl leading-none text-gray-400 transition hover:text-gray-700"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
      <DialogContent>
        <div className="py-1">
          <label className="mb-1.5 block text-sm font-semibold text-gray-700">
            {label} Location <span className="text-red-500">*</span>
          </label>
          <select
            value={dropdownValue}
            onChange={(e) => onLocationChange(e.target.value)}
            className="mb-4 w-full rounded-xl border border-gray-300 p-2.5 text-sm outline-none focus:border-blue-500"
          >
            <option value="Select">Select</option>
            {LOCATIONS.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          <label className="mb-1.5 block text-sm font-semibold text-gray-700">
            Comments
          </label>
          <textarea
            value={comments}
            onChange={(e) => onCommentsChange(e.target.value)}
            className="mb-5 w-full rounded-xl border border-gray-300 p-2.5 text-sm text-black outline-none focus:border-blue-500"
            rows={3}
            placeholder="Comments"
          />

          <div className="flex justify-end">
            {isLoading ? (
              <div className="animate-pulse bg-gradient-to-r from-blue-700 to-transparent bg-clip-text text-xl text-blue-400">
                Loading...
              </div>
            ) : (
              <button
                id={signingOut ? "signOutButton" : "signInButton"}
                type="button"
                className={`rounded-xl px-6 py-2.5 text-sm font-bold transition ${
                  disabled
                    ? "cursor-not-allowed bg-gray-300 text-gray-600"
                    : "cursor-pointer bg-blue-600 text-white hover:bg-blue-700"
                }`}
                onClick={onSubmit}
                disabled={disabled}
              >
                {label}
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AttendanceDialog;
